<template>
    <p>MyLiebherr-B2C_Portal is running!</p>
</template>